export enum ConfirmStatus {
  Unconfirmed = 0,
  Confirmed = 1,
  AutoConfirmed = 2,
}

export enum AppealStatus {
  Submitted = 0,
  Handling = 1,
  Finished = 2,
  Reject = 3,
  Withdraw = 4,
}

export const FieldMap = {
  [AppealStatus.Submitted]: { time: "createTime", next: AppealStatus.Handling },
  [AppealStatus.Handling]: {
    time: "processTime",
    next: [AppealStatus.Finished, AppealStatus.Reject, AppealStatus.Withdraw],
  },
  [AppealStatus.Finished]: {
    time: "processFinishTime",
    next: "",
    icon: "FinishIcon",
  },
  [AppealStatus.Reject]: { time: "rejectTime", next: "", icon: "RevokeIcon" },
  [AppealStatus.Withdraw]: {
    time: "revokeTime",
    next: "",
    icon: "TurnDownIcon",
  },
};
